<div class="blog-post-title">
  {{ post.title }}
</div>
<div class="blog-post-subtitle">
  {{ post.subtitle }}
</div>
<div class="blog-post-body" [innerHTML]="post.body">
</div>
